export enum ProspectiveStudiesDemoGroupType {
    FIRSTGROUP = 'FIRSTGROUP',
}
